import React from 'react';

export function Home({ go }: { go: (x: string) => void }) {
  return (
    <div className="container">
      <section className="hero">
        <h1>Nền tảng Luyện thi ĐGNL 
          <br /><span className="text-gradient">Đẳng cấp hàng đầu</span>
        </h1>
        <p>
          Math ĐGNL cung cấp bộ câu hỏi chuẩn hóa cao độ, giao diện tập trung và phân tích năng lực chi tiết giúp bạn chinh phục các kỳ thi HSA, TSA và V-ACT dễ dàng nhất.
        </p>
        <div className="flex justify-center gap-4">
          <button className="btn btn-primary" onClick={() => go('exam')}>
            Thi thử ngay 🚀
          </button>
          <button className="btn btn-secondary" onClick={() => go('practice')}>
            Bắt đầu luyện tập
          </button>
        </div>
      </section>

      <section className="features-grid">
        <div className="card feature-card">
          <div className="feature-icon">🧠</div>
          <h3>Luyện tập chuyên sâu</h3>
          <p>Hàng ngàn câu hỏi được thiết kế theo đúng taxonomy kép (Kiến thức + Năng lực), giúp lấp đầy lỗ hổng kiến thức ngay tức thì.</p>
        </div>

        <div className="card feature-card">
          <div className="feature-icon">⏱️</div>
          <h3>Thi thử mô phỏng 100%</h3>
          <p>Trải nghiệm áp lực phòng thi thực tế với đồng hồ đếm ngược và cấu trúc đề thi bám sát form đề mẫu của các trường Đại học.</p>
        </div>

        <div className="card feature-card">
          <div className="feature-icon">📊</div>
          <h3>Phân tích năng lực</h3>
          <p>Hệ thống phân tích thông minh bằng Dashboard, giúp bạn và phụ huynh dễ dàng theo dõi tiến độ và điểm số theo thời gian.</p>
        </div>
      </section>
    </div>
  )
}
